module.exports = __webpack_public_path__ + "img/kairan.f1ccdc2b.png";